"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runMacroOnChangeSet = exports.runMacroOnValue = exports.compileMacroFunction = exports.runMacro = void 0;
const lodash_1 = __importDefault(require("lodash"));
const v1_1 = __importDefault(require("uuid/v1"));
const v4_1 = __importDefault(require("uuid/v4"));
const moment_1 = __importDefault(require("moment"));
const ChangeSet_1 = require("./ChangeSet");
const getMacroFunction = {
    transformValue: code => `
(value, args, modules, rowIndex, row, columnName) => {
    ${code}
}
`,
    transformRows: code => `
(rows, args, modules, selectedCells, cols, columns) => {
  ${code}
}
`,
    transformData: code => `
(rows, args, modules, selectedCells, cols, columns) => {
  ${code}
}
`,
};
const modules = {
    lodash: lodash_1.default,
    uuidv1: v1_1.default,
    uuidv4: v4_1.default,
    moment: moment_1.default,
};
function runTramsformValue(func, macroArgs, data, preview, selectedCells, errors = []) {
    const selectedRows = lodash_1.default.groupBy(selectedCells, 'row');
    const rows = data.rows.map((row, rowIndex) => {
        const selectedRow = selectedRows[rowIndex];
        if (selectedRow) {
            const modifiedFields = [];
            let res = null;
            for (const cell of selectedRow) {
                const { column } = cell;
                const oldValue = row[column];
                let newValue = oldValue;
                try {
                    newValue = func(oldValue, macroArgs, modules, rowIndex, row, column);
                }
                catch (err) {
                    errors.push(`Error processing column ${column} on row ${rowIndex}: ${err.message}`);
                }
                if (newValue != oldValue) {
                    if (res == null) {
                        res = Object.assign({}, row);
                    }
                    res[column] = newValue;
                    if (preview)
                        modifiedFields.push(column);
                }
            }
            if (res) {
                if (modifiedFields.length > 0) {
                    return Object.assign(Object.assign({}, res), { __modifiedFields: new Set(modifiedFields) });
                }
                return res;
            }
            return row;
        }
        else {
            return row;
        }
    });
    return {
        structure: data.structure,
        rows,
    };
}
function removePreviewRowFlags(rows) {
    rows = rows.filter(row => row.__rowStatus != 'deleted');
    rows = rows.map(row => {
        if (row.__rowStatus || row.__modifiedFields || row.__insertedFields || row.__deletedFields)
            return lodash_1.default.omit(row, ['__rowStatus', '__modifiedFields', '__insertedFields', '__deletedFields']);
        return row;
    });
    return rows;
}
function runTramsformRows(func, macroArgs, data, preview, selectedCells, errors = []) {
    let rows = data.rows;
    try {
        rows = func(data.rows, macroArgs, modules, selectedCells, data.structure.columns.map(x => x.columnName), data.structure.columns);
        if (!preview) {
            rows = removePreviewRowFlags(rows);
        }
    }
    catch (err) {
        errors.push(`Error processing rows: ${err.message}`);
    }
    return {
        structure: data.structure,
        rows,
    };
}
function runTramsformData(func, macroArgs, data, preview, selectedCells, errors = []) {
    try {
        let { rows, columns, cols } = func(data.rows, macroArgs, modules, selectedCells, data.structure.columns.map(x => x.columnName), data.structure.columns);
        if (cols && !columns) {
            columns = cols.map(columnName => ({ columnName }));
        }
        columns = lodash_1.default.uniqBy(columns, 'columnName');
        if (!preview) {
            rows = removePreviewRowFlags(rows);
        }
        return {
            structure: { columns },
            rows,
        };
    }
    catch (err) {
        errors.push(`Error processing data: ${err.message}`);
    }
    return data;
}
function runMacro(macro, macroArgs, data, preview, selectedCells, errors = []) {
    let func;
    try {
        func = eval(getMacroFunction[macro.type](macro.code));
    }
    catch (err) {
        errors.push(`Error compiling macro ${macro.name}: ${err.message}`);
        return data;
    }
    if (macro.type == 'transformValue') {
        return runTramsformValue(func, macroArgs, data, preview, selectedCells, errors);
    }
    if (macro.type == 'transformRows') {
        return runTramsformRows(func, macroArgs, data, preview, selectedCells, errors);
    }
    if (macro.type == 'transformData') {
        // @ts-ignore
        return runTramsformData(func, macroArgs, data, preview, selectedCells, errors);
    }
    return data;
}
exports.runMacro = runMacro;
function compileMacroFunction(macro, errors = []) {
    if (!macro)
        return null;
    let func;
    try {
        func = eval(getMacroFunction[macro.type](macro.code));
        return func;
    }
    catch (err) {
        errors.push(`Error compiling macro ${macro.name}: ${err.message}`);
        return null;
    }
}
exports.compileMacroFunction = compileMacroFunction;
function runMacroOnValue(compiledFunc, macroArgs, value, rowIndex, row, column, errors = []) {
    if (!compiledFunc)
        return value;
    try {
        const res = compiledFunc(value, macroArgs, modules, rowIndex, row, column);
        return res;
    }
    catch (err) {
        errors.push(`Error processing column ${column} on row ${rowIndex}: ${err.message}`);
        return value;
    }
}
exports.runMacroOnValue = runMacroOnValue;
function runMacroOnChangeSet(macro, macroArgs, selectedCells, changeSet, display) {
    const errors = [];
    const compiledMacroFunc = compileMacroFunction(macro, errors);
    if (!compiledMacroFunc)
        return null;
    let res = changeSet;
    for (const cell of selectedCells) {
        const definition = display.getChangeSetField(cell.rowData, cell.column, undefined);
        const macroResult = runMacroOnValue(compiledMacroFunc, macroArgs, cell.value, cell.row, cell.rowData, cell.column, errors);
        res = (0, ChangeSet_1.setChangeSetValue)(res, definition, macroResult);
    }
    return res;
}
exports.runMacroOnChangeSet = runMacroOnChangeSet;
